import React, { useId } from 'react'

// Small self-contained flag SVGs (no icon-font dependency). Each fills its
// viewBox and crops via preserveAspectRatio, so the fixed-size .flag box in
// CSS gives all four a consistent size despite their different official
// proportions.

function DeFlag() {
  return (
    <svg viewBox="0 0 5 3" preserveAspectRatio="xMidYMid slice" role="presentation">
      <rect width="5" height="1" fill="#000" />
      <rect y="1" width="5" height="1" fill="#D00" />
      <rect y="2" width="5" height="1" fill="#FFCE00" />
    </svg>
  )
}

function BgFlag() {
  return (
    <svg viewBox="0 0 5 3" preserveAspectRatio="xMidYMid slice" role="presentation">
      <rect width="5" height="1" fill="#fff" />
      <rect y="1" width="5" height="1" fill="#00966E" />
      <rect y="2" width="5" height="1" fill="#D62612" />
    </svg>
  )
}

function TrFlag() {
  return (
    <svg viewBox="0 0 3 2" preserveAspectRatio="xMidYMid slice" role="presentation">
      <rect width="3" height="2" fill="#E30A17" />
      <circle cx="1" cy="1" r="0.62" fill="#fff" />
      <circle cx="1.18" cy="1" r="0.52" fill="#E30A17" />
      <polygon
        points="1.72,0.78 1.769,0.932 1.929,0.932 1.8,1.026 1.849,1.178 1.72,1.084 1.591,1.178 1.64,1.026 1.511,0.932 1.671,0.932"
        fill="#fff"
      />
    </svg>
  )
}

// Union Jack, used for English. Simplified (the diagonals aren't
// counter-changed per quadrant) but reads correctly at icon size.
function GbFlag() {
  const clipId = useId()
  return (
    <svg viewBox="0 0 60 30" preserveAspectRatio="xMidYMid slice" role="presentation">
      <clipPath id={clipId}>
        <rect width="60" height="30" />
      </clipPath>
      <g clipPath={`url(#${clipId})`}>
        <rect width="60" height="30" fill="#012169" />
        <path d="M0,0 60,30 M60,0 0,30" stroke="#fff" strokeWidth="6" />
        <path d="M0,0 60,30 M60,0 0,30" stroke="#C8102E" strokeWidth="4" />
        <path d="M30,0 30,30 M0,15 60,15" stroke="#fff" strokeWidth="10" />
        <path d="M30,0 30,30 M0,15 60,15" stroke="#C8102E" strokeWidth="6" />
      </g>
    </svg>
  )
}

const FLAGS = { de: DeFlag, en: GbFlag, bg: BgFlag, tr: TrFlag }

function Flag({ code, className = '' }) {
  const FlagIcon = FLAGS[code]
  if (!FlagIcon) return null
  return (
    <span className={`flag ${className}`.trim()}>
      <FlagIcon />
    </span>
  )
}

export default Flag
